/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { createConversionGroupCondition, ModelType, modelType, ModelWithConversion } from 'cio/utils/conversions';

interface CampaignsConversionSummaryArgs {
  model: ModelWithConversion;
  capitalize?: boolean;
  showTimeframe?: boolean;
  showFilters?: boolean;
}

export default class CampaignsConversionSummary extends Component<CampaignsConversionSummaryArgs> {
  readonly ModelType = ModelType;

  get modelType() {
    return modelType(this.args.model);
  }

  @computed('args.model.{conversionEventName,conversionEventFilters}')
  get conversionGoalConditions() {
    return createConversionGroupCondition(this.args.model);
  }

  get showFilters() {
    return this.args.showFilters ?? true;
  }
}
